import { SettingType } from "./Setting.js";

export interface CertSettingType {
  check_in: SettingType;
  completion: SettingType;
  kickoff: SettingType;
  kickoff_response: SettingType;
  office_hours: SettingType;
  program_eval: SettingType;
  reflection: SettingType;
}

export const CertSettingTypeDefaults: CertSettingType = {
  check_in: {value_max: 0, value_min: 0, value: '', user_note: '', title: ''},
  completion: {value_max: 0, value_min: 0, value: '', user_note: '', title: ''},
  kickoff: {value_max: 0, value_min: 0, value: '', user_note: '', title: ''},
  kickoff_response: {value_max: 0, value_min: 0, value: false, user_note: '', title: ''},
  office_hours: {value_max: 0, value_min: 0, value: '', user_note: '', title: ''},
  program_eval: {value_max: 0, value_min: 0, value: false, user_note: '', title: ''},
  reflection: {value_max: 0, value_min: 0, value: '', user_note: '', title: ''},
};

export interface CertType { 
  check_in: number;
  completion: number;
  kickoff: number;
  kickoff_response: boolean;
  office_hours: number;
  program_eval: boolean;
  reflection: number;
 };

 export const CertTypeDefaults: CertType = {
  check_in: 0,
  completion: 0,
  kickoff: 0,
  kickoff_response: false,
  office_hours: 0,
  program_eval: false,
  reflection: 0
 }

 export const calcCert = (cert: CertType, certReqs: CertSettingType): {certPct: number, certTip: string} => {

  let total = 0;
  let cert_total = ((certReqs.kickoff?.value_min) || 0) + ((certReqs.check_in?.value_min) || 0) + ((certReqs.completion?.value_min) || 0) + ((certReqs.reflection?.value_min) || 0) + ((certReqs.office_hours?.value_min) || 0);
  if (certReqs.program_eval && certReqs.program_eval.value) cert_total += 1;
  if (certReqs.kickoff_response && certReqs.kickoff_response.value ) cert_total += 1;
  let tip = '';
  
  if (((certReqs.kickoff?.value_min) || 0) > 0 && cert.kickoff > 0) {
    if (cert.kickoff > ((certReqs.kickoff?.value_max) || 0)) total += ((certReqs.kickoff?.value_max) || 0);
    else total += cert.kickoff;
    tip += cert.kickoff + ' KickOff';
    if (cert.kickoff > 1) tip += 's';
    tip += ', ';
  }
  if (certReqs.kickoff_response?.value && cert.kickoff_response) {
    total += 1;
    tip += 'Kickoff Response, ';
  }
  if (((certReqs.check_in?.value_min) || 0) > 0 && cert.check_in > 0) {
    if (cert.check_in > ((certReqs.check_in?.value_max) || 0)) total += ((certReqs.check_in?.value_max) || 0);
    else total += cert.check_in;
    tip += cert.check_in + ' Check-In';
    if (cert.check_in > 1) tip += 's';
    tip += ', ';
  }
  if (((certReqs.completion?.value_min) || 0) > 0 && cert.completion > 0) {
    if (cert.completion > ((certReqs.completion?.value_max) || 0)) total += ((certReqs.completion?.value_max) || 0);
    else total += cert.completion;
    tip += cert.completion + ' Completion';
    if (cert.completion > 1) tip += 's';
    tip += ', ';
  }
  if (((certReqs.office_hours?.value_min) || 0) > 0 && cert.office_hours > 0) {
    if (cert.office_hours > ((certReqs.office_hours?.value_max) || 0)) total += ((certReqs.office_hours?.value_max) || 0);
    else total += cert.office_hours;
    tip += cert.office_hours + ' Office Hours';
    tip += ', ';
  }
  if (((certReqs.reflection?.value_min) || 0) > 0 && cert.reflection > 0) {
    if (cert.reflection > ((certReqs.reflection?.value_max) || 0)) total += ((certReqs.reflection?.value_max) || 0);
    else total += cert.reflection;
    tip += cert.reflection + ' Reflection';
    if (cert.reflection > 1) tip += 's';
    tip += ', ';
  }
  if (certReqs.program_eval?.value && cert.program_eval) {
    total += 1;
    tip += 'Program Evaluation, ';
  }
  if (tip.length > 0) tip = tip.slice(0, -2);
  
  const certPct = cert_total > 0 ? Math.round((100.0 * total) / cert_total) : 0;
  
  return {certPct, certTip: tip};
};